<template>
  <v-app>
    <v-content class="background py-8">
      <v-container>
        <v-row>
          <v-col md="10" offset="1">
            <v-row>
              <v-col class="card-background" md="6" sm="12">
                <div id="particles-js"></div>
                <v-row align="center" class="fill-height">
                  <v-col cols="12" class="pa-12" align-self="start">
                    <strong class="display-3 font-weight-bold">
                      <div
                        class="text-left teal--text text--lighten-1"
                        v-html="rhrCoreShellOptions.slogan"
                      ></div>
                    </strong>
                  </v-col>
                  <v-col cols="12" align-self="end" class="pa-12">
                    <v-img
                      v-if="rhrCoreShellOptions.logo"
                      width="150"
                      :src="rhrCoreShellOptions.logo"
                      contain
                    ></v-img>
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="6" sm="12" class="white">
                <v-row>
                  <v-col>
                    <v-img
                      v-if="rhrCoreShellOptions.logo"
                      :src="rhrCoreShellOptions.logo"
                      contain
                      height="40"
                      aspect-ratio="1"
                    ></v-img>
                  </v-col>
                </v-row>
                <v-col>
                  <slot></slot>
                </v-col>
                <v-row align="end" justify="center">
                  <v-btn text small>
                    &copy; 2018
                  </v-btn>
                  <v-btn
                    :to="{ name: `account-privacy-and-policy` }"
                    text
                    small
                  >
                    Privacy Policy
                  </v-btn>
                  <v-btn
                    :to="{ name: `account-terms-and-condition` }"
                    text
                    small
                  >
                    Terms and Conditions
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
export default {
  data() {
    return {
      rhrCoreShellOptions: {},
      particlesSetup: {
        particles: {
          number: {
            value: 35
          },
          color: {
            value: ["#5CA3EB", "#00cd80", "#384977"]
          },
          shape: {
            type: "circle"
          },
          size: {
            value: 5,
            anim: {
              enable: true,
              speed: 0.5,
              opacity_min: 10,
              sync: false
            }
          },
          line_linked: {
            enable: false
          },
          move: {
            enable: true,
            speed: 1,
            direction: "top-left",
            straight: true,
            out_mode: "out"
          }
        },
        interactivity: {
          events: {
            onhover: {
              enable: false
            },
            onclick: {
              enable: false
            },
            resize: true
          }
        }
      }
    };
  },
  mounted() {
    this.rhrCoreShellOptions = window.rhrCoreShellOptions;
  }
};
</script>

<style scoped>
#particles-js {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 80%;
}
.background {
  background: rgba(38, 60, 98, 1) url("/images/auth/background_login.jpg")
    no-repeat center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%;
}
.card-background {
  background: rgb(20, 52, 92);
  background: linear-gradient(
    140deg,
    rgba(20, 52, 92, 1) 14%,
    rgba(13, 27, 54, 1) 60%
  );
}
.card-content {
  background: rgb(237, 237, 237);
  background: linear-gradient(
    90deg,
    rgba(237, 237, 237, 1) 9%,
    rgba(255, 255, 255, 1) 23%
  );
}
@media only screen and (max-height: 600px) {
  #bottom-links {
    position: static !important;
  }
}
</style>
